import React from "react";
import AgribusinessStack from "../AgribusinessStack/AgribusinessStack";
import "./ForFarmers.css";

import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";

// Main component for DTN Deployment for Agri-Entrepreneurs
export default function ForFarmers() {
  return (
    <>
      {/* Banner section */}
      <AgribusinessStack
        classname="farmUpdateBanner"
        level1="System Integrator"
        level2="Agribusiness"
        level3="Agri-Entrepreneur"
      />

      {/* Section representing DTN deployment for agri-entrepreneurs */}
      <SolutionEcosystem
        title="DTN Deployment for Agri-Entrepreneur"
        type="AE"
        bodycopy="AAMC is a type of DTN network where agri-entrepreneurs can join to monetize unutilized farming capacity."
      />

    </>
  );
}
